export enum SenderRole {
  USER = 'user',
  ASSISTANT = 'assistant',
}
